import { postRequest } from '../clients/axios';
import { SaveSubnavOrderPayload } from '../models';

// appUserId - The ID of the application user.
// setting - The serialized setting string (e.g., '{"subnav":"driver, irons, hybrid"}').
export const postSaveSubnavOrder = async (appUserId: number, setting: string) => {
  const url = 'appsetting/SaveOrderEntryAppUserSetting';

  // appUserSettingId and appSectionId are hardcoded per requirement
  const appUserSettingId = 215;
  const appSectionId = 8;

  const payload: SaveSubnavOrderPayload = {
    appUserSetting: {
      appUserSettingId,
      appUserId,
      appSectionId,
      setting,
      // default configs
      sortId: 1,
      isActive: true,
    },
  };

  const response = await postRequest(url, payload);
  return response.data;
};
